import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Error404.css';

class Error404 extends Component {
  render() {
    return (
      <div className="error404">
        <Grid>
          <Row>
            <Col md={12}>
              <h1>Page not found!</h1>
              <h2>
                Sorry, but the page you were looking for could not be found.
              </h2>
              <p>
                You can return to our{' '}
                <Link to="/home/" className="link">
                  home page
                </Link>
                , or <a href="mailto:info@distilledID.com"> drop us a line </a>
                if you can't find what you're looking for.
              </p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/components/common/Error404.js